import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { formatDate } from "../../utilities/format";

const styles = () => ({
  centerAlign: {
    verticalAlign: "middle",
  },
});

const DateCheckmark = ({ classes, date }) => {
  return (
    <React.Fragment>
      <CheckCircle color="primary" className={classes.centerAlign} />{" "}
      <span className={classes.centerAlign}>{formatDate(date)}</span>
    </React.Fragment>
  );
};
DateCheckmark.propTypes = {
  classes: PropTypes.object.isRequired,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default withStyles(styles)(DateCheckmark);



// WEBPACK FOOTER //
// ./src/components/UI/DateCheckmark.jsx